import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { OptionTurnosData } from "../Sidebar/OptionTurnosData";
import { OptionResultadosData } from "../Sidebar/OptionResultadosData";
import { OptionInformacionData } from "../Sidebar/OptionInformacionData";
import { logoutApp } from "../../../../global/context/action/auth/logoutApp";
import { useHistory } from "react-router";
import { logoutPaciente } from "../../../context/Actions/paciente/paciente";
import "./FooterBar.css";
import { resetDropdown } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { recetasDigitalesReset } from "../../../context/Actions/turnos/recetaDigital";
import { resetListaFamiliares } from "../../../context/Actions/listaFamiliares/listasFamiliares";
import { resetEstudioGrupo } from "../../../context/Actions/estudioGrupo/estudioGrupo";
import { resetLaboGrupo } from "../../../context/Actions/laboGrupo/laboGrupo";
import { resetMultitab } from "../../../context/Actions/multiTab/multiTab";
import { localidadReset } from "../../../context/Actions/localidad/localidad";
import { grupoFamiliarReset } from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { resetTurnosPaciente } from "../../../context/Actions/turnos/turnosPaciente";
import { misLaboratoriosReset } from "../../../context/Actions/misLaboratorios/misLaboratorios";
import { misInformesReset } from "../../../context/Actions/misInformes/misInformes";
import { misMedicosReset } from "../../../context/Actions/misMedicos/misMedicos";
import { tokenLogout } from "../../../context/Actions/token/logoutToken";
import { dispositivoPacienteReset } from "../../../context/Actions/dispositivoPaciente/dispositivoPaciente";
import { GlobalContext } from "../../../../global/context/Provider";
import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";

const FooterBar = () => {
  const {
    modalDispatch,
    pacienteDispatch,
    multiTabState,
    tokenDispatch,
    misMedicosDispatch,
    misInformesDispatch,
    misLaboratoriosDispatch,
    turnosPacienteDispatch,
    grupoFamiliarDispatch,
    localidadDispatch,
    multiTabDispatch,
    laboGrupoDispatch,
    estudioGrupoDispatch,
    listaFamiliaresDispatch,
    recetasDigitalesDispatch,
    selectDropDownDispatch,
    dispositivoPacienteDispatch,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authDispatch, authState, configState } = useContext(GlobalContext);

  const [activo, setActivo] = useState("");
  const vacio = () => {
    return null;
  };

  const history = useHistory();
  const logOut = () => {
    if (authState.authTraza.data !== null) {
      wsPostLogoutTraza(authState.authTraza.data.id, {
        ingreso: false,
        sector: configState.config.data.sectorTurno,
      })(authDispatch);
    }
    logoutApp(history)(authDispatch);
    logoutPaciente(history)(pacienteDispatch);
    tokenLogout(history)(tokenDispatch);
    misMedicosReset()(misMedicosDispatch);
    misInformesReset()(misInformesDispatch);
    misLaboratoriosReset()(misLaboratoriosDispatch);
    resetTurnosPaciente()(turnosPacienteDispatch);
    grupoFamiliarReset()(grupoFamiliarDispatch);
    localidadReset()(localidadDispatch);
    resetMultitab()(multiTabDispatch);
    resetLaboGrupo()(laboGrupoDispatch);
    resetEstudioGrupo()(estudioGrupoDispatch);
    resetListaFamiliares()(listaFamiliaresDispatch);
    recetasDigitalesReset()(recetasDigitalesDispatch);
    resetDropdown()(selectDropDownDispatch);
    dispositivoPacienteReset()(dispositivoPacienteDispatch); // ✅ Reset del estado de dispositivo
    hideModal()(modalDispatch);
  };

  const [turnosData, setTurnosData] = useState(OptionTurnosData);
  const [resultadosData, setResultadosData] = useState(OptionResultadosData);
  const [informacionData, setInformacionData] = useState(OptionInformacionData);

  let config = localStorage.getItem("config");
  let opcLabo = JSON.parse(config).opcLaboratorio;
  let opcVL = JSON.parse(config).opcVideoLlamada;
  let opcRD = JSON.parse(config).opcRecetaDigital;
  let opcVT = JSON.parse(config).opcVideotutoriales;
  let opcATSinTurno = JSON.parse(config).opcAtencionSinTurnoPrevio;
  let opcAyuda = JSON.parse(config).opcBot;

  //ESTE USEEFFECT SE FIJA LOS TABS DE INFORMACION SEGUN EL JSON
  useEffect(() => {
    if (opcAyuda === false) {
      var filtroAyuda = informacionData.findIndex(function (o) {
        return o.key === 15;
      });
      if (filtroAyuda !== -1) informacionData.splice(filtroAyuda, 1);
    }
    if (opcVT === false) {
      var filtroTutoriales = informacionData.findIndex(function (o) {
        return o.key === 14;
      });
      if (filtroTutoriales !== -1) informacionData.splice(filtroTutoriales, 1);
    }
    if (opcLabo === false) {
      var filtroMisLabo = resultadosData.findIndex(function (o) {
        return o.key === 8;
      });
      if (filtroMisLabo !== -1) resultadosData.splice(filtroMisLabo, 1);
    }
    if (opcLabo === false) {
      var filtroLabo = turnosData.findIndex(function (o) {
        return o.key === 2;
      });
      if (filtroLabo !== -1) turnosData.splice(filtroLabo, 1);
      var filtroPCR = turnosData.findIndex(function (o) {
        return o.key === 7;
      });
      if (filtroPCR !== -1) turnosData.splice(filtroPCR, 1);
    }
    if (opcRD === false) {
      var filtroReceta = turnosData.findIndex(function (o) {
        return o.key === 3;
      });
      if (filtroReceta !== -1) turnosData.splice(filtroReceta, 1);
    }
    if (opcVL === false) {
      var filtroVideo = turnosData.findIndex(function (o) {
        return o.key === 5;
      });
      if (filtroVideo !== -1) turnosData.splice(filtroVideo, 1);
    }
    if (opcATSinTurno === false) {
      var filtroAtencion = turnosData.findIndex(function (o) {
        return o.key === 6;
      });
      if (filtroAtencion !== -1) turnosData.splice(filtroAtencion, 1);
    }
  }, []);

  const abrirModal = (captionOpc) => {
    let listOpciones;
    let clase = "";
    if (captionOpc === "Turnos") {
      listOpciones = OptionTurnosData;
      clase = "turnosMobileSidebar";
      setActivo(captionOpc);
    } else if (captionOpc === "Resultados") {
      listOpciones = OptionResultadosData;
      clase = "resultadosMobileSidebar";
      setActivo(captionOpc);
    } else {
      listOpciones = OptionInformacionData;
      clase = "resultadosMobileSidebar";
      setActivo(captionOpc);
    }
    //{ caption, items, expanded, headerClickHandler }
    showModal(
      "Genericos/OptionSidebar/OptionSidebar",
      {
        caption: captionOpc,
        items: listOpciones,
        expanded: true,
        turnosMobileSidebar: clase,
        headerClickHandler: vacio,
        handleClickLogout: logOut,
      },
      null,
      "centroAbajo"
    )(modalDispatch);
  };

  useEffect(() => {
    if (multiTabState.multiTab.paso >= 0 && multiTabState.multiTab.paso <= 7) {
      setActivo("Turnos");
    }
    if (multiTabState.multiTab.paso >= 8 && multiTabState.multiTab.paso <= 9) {
      setActivo("Resultados");
    } else if (multiTabState.multiTab.paso > 9) {
      setActivo("Información");
    }
  }, [multiTabState.multiTab.paso]);

  return (
    <div className="ptur-FooterBarDiv c-white">
      <div className="ptur-btnFooter">
        <button
          className={`btnTurnosMobile ${
            activo === "Turnos" ? "activeBtn" : ""
          }`}
          onClick={() => abrirModal("Turnos")}
        >
          <span className="rb18b span-footerTurnos">Turnos</span>
        </button>
        <button
          className={`btnResultadosMobile ${
            activo === "Resultados" ? "activeBtn" : ""
          }`}
          onClick={() => abrirModal("Resultados")}
        >
          <span className="rb18b span-footerResultados">Resultados </span>
          {/* <NotificationFooter /> */}
        </button>
        <button
          className={`btnInformacionMobile ${
            activo === "Información" ? "activeBtn" : ""
          }`}
          onClick={() => abrirModal("Información")}
        >
          <span className="rb18b span-footerInfo">Info.</span>
        </button>
      </div>
    </div>
  );
};

export default FooterBar;
